<template>
  <div>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-container>
      <v-row v-if="region">
        <v-col class="text-right">
          <v-btn class="ma-2" color="red" :to="'/covid-tracker/' + region" dark
            >View data for {{ region }}</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h1 class="text-center">USA COVID-19 Tracker</h1>
        </v-col>
      </v-row>
      <v-row v-if="arrPositive.length > 0 && !isLoading">
        <v-col>
          <v-card class="pa-3">
            <h2 class="text-center">Positive</h2>
            <line-chart
              :chartData="arrPositive"
              :options="chartOptions"
              :chartColors="positiveChartColors"
              label="Positive"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="arrHospitalized.length > 0 && !isLoading">
        <v-col>
          <v-card class="pa-3">
            <h2 class="text-center">Hospitalized</h2>
            <line-chart
              :chartData="arrHospitalized"
              :options="chartOptions"
              :chartColors="hospitalizedChartColors"
              label="Hospitalized"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="arrInIcu.length > 0 && !isLoading">
        <v-col>
          <v-card class="pa-3">
            <h2 class="text-center">In ICU</h2>
            <line-chart
              :chartData="arrInIcu"
              :options="chartOptions"
              :chartColors="inIcuColors"
              label="In ICU"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="arrOnVentilators.length > 0 && !isLoading">
        <v-col>
          <v-card class="pa-3">
            <h2 class="text-center">On Ventilators</h2>
            <line-chart
              :chartData="arrOnVentilators"
              :options="chartOptions"
              :chartColors="onVentilatorsColors"
              label="On Ventilators"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="arrRecovered.length > 0 && !isLoading">
        <v-col>
          <v-card class="pa-3">
            <h2 class="text-center">Recovered</h2>
            <line-chart
              :chartData="arrRecovered"
              :options="chartOptions"
              :chartColors="recoveredColors"
              label="Recovered"
            />
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="arrDeaths.length > 0 && !isLoading">
        <v-col>
          <v-card class="pa-3">
            <h2 class="text-center">Deaths</h2>
            <line-chart
              :chartData="arrDeaths"
              :options="chartOptions"
              :chartColors="deathColors"
              label="Deaths"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

import LineChart from "@/components/covid-charts/LineChart";
export default {
  components: {
    LineChart
  },
  data() {
    return {
      arrPositive: [],
      positiveChartColors: {
        borderColor: "#077187",
        pointBorderColor: "#0E1428",
        pointBackgroundColor: "#AFD6AC",
        backgroundColor: "#74A57F"
      },
      arrHospitalized: [],
      hospitalizedChartColors: {
        borderColor: "#251F47",
        pointBorderColor: "#260F26",
        pointBackgroundColor: "#858EAB",
        backgroundColor: "#858EAB"
      },
      arrInIcu: [],
      inIcuColors: {
        borderColor: "#190B28",
        pointBorderColor: "#190B28",
        pointBackgroundColor: "#E55381",
        backgroundColor: "#E55381"
      },
      arrOnVentilators: [],
      onVentilatorsColors: {
        borderColor: "#784F41",
        pointBorderColor: "#784F41",
        pointBackgroundColor: "#BBE5ED",
        backgroundColor: "#BBE5ED"
      },
      arrRecovered: [],
      recoveredColors: {
        borderColor: "#4E5E66",
        pointBorderColor: "#4E5E66",
        pointBackgroundColor: "#31E981",
        backgroundColor: "#31E981"
      },
      arrDeaths: [],
      deathColors: {
        borderColor: "#E06D06",
        pointBorderColor: "#E06D06",
        pointBackgroundColor: "#402A2C",
        backgroundColor: "#402A2C"
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      isLoading: false,
      regionName: "",
      region: ""
    };
  },
  async created() {
    this.isLoading = true;

    try {
      const res = await axios.get("https://extreme-ip-lookup.com/json/");
      if (res.data.countryCode === "US") {
        this.region = res.data.region;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }

    const { data } = await axios.get("https://covidtracking.com/api/us/daily");

    data.forEach(d => {
      const date = moment(d.date, "YYYYMMDD").format("MM/DD");
      const {
        positive,
        hospitalizedCurrently,
        inIcuCurrently,
        onVentilatorCurrently,
        recovered,
        death
      } = d;

      this.arrPositive.push({ date, total: positive });
      this.arrHospitalized.push({ date, total: hospitalizedCurrently });
      this.arrInIcu.push({ date, total: inIcuCurrently });
      this.arrOnVentilators.push({ date, total: onVentilatorCurrently });
      this.arrRecovered.push({ date, total: recovered });
      this.arrDeaths.push({ date, total: death });
    });

    this.isLoading = false;
  }
};
</script>
